import ProposalCommentThread from "@/components/proposals/ProposalCommentThread";

interface FollowUpStepProps {
  data: any;
}

const FollowUpStep = ({ data }: FollowUpStepProps) => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold mb-2">Follow Up</h2>
        <p className="text-sm text-muted-foreground">Track updates and notes shared by everyone working on this proposal</p>
      </div>

      {data?.id ? (
        <ProposalCommentThread proposalId={data.id} />
      ) : (
        <p className="text-sm text-muted-foreground">Save the proposal to start the follow-up thread.</p>
      )}
    </div>
  );
};

export default FollowUpStep;
